import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { mergeMap, switchMap } from 'rxjs/operators';

import { TYPE_SUCCESS } from '../../../common/constants/snackbar';

import { getMainPlayerWidget } from '../../../common/components/Player/helpers';
import { getLinks, getMentions, getText } from '../../../common/helpers/comments';
import { gqlRequest } from '../../../common/helpers/request';
import { notifyAction } from '../../../common/redux/slices/snackbar';
import { deleteCommentAction, getCommentsAndSummaryAction } from '../slices/comments';

const queryGQL = `
  mutation hostedWatchDeleteComment($commentId: String) {
    hostedWatchDeleteComment(commentId: $commentId)  {
      id,
    }
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(deleteCommentAction.type),
    mergeMap(({ payload }) =>
      gqlRequest({
        query: queryGQL,
        variables: {
          commentId: payload.id,
        },
      }).pipe(
        switchMap(({ errors }) => {
          const actions = [];

          if (!errors.length) {
            const LWP = getMainPlayerWidget();

            LWP.sendStatsDeleteComment(
              payload.parentId ? 2 : 1,
              payload.index,
              getText(payload.html).length,
              !!getMentions(payload.html).length,
              !!getLinks(payload.html).length,
            );
            actions.push(
              of(
                notifyAction({
                  variant: TYPE_SUCCESS,
                  message: !payload.parentId ? 'Comment thread deleted' : 'Comment deleted',
                }),
              ),
            );
          } else {
            const getCommentsInfoPayload = {
              videoId: payload.videoId,
              videoTime: {
                from: 0,
              },
              from: 0, // portion start
              size: 10000,
            };

            actions.push(of(getCommentsAndSummaryAction(getCommentsInfoPayload)));
          }

          return concat(...actions);
        }),
      ),
    ),
  );
